export { ClickAwayListener as default } from './ClickAwayListener';
export type { ClickAwayListenerProps } from './ClickAwayListener';
